const TRANSMITTED_REASSIGN_TYPES = {
  YOUR: 'your',
  CUSTOM: 'custom',
};

export default TRANSMITTED_REASSIGN_TYPES;
